import clsx from 'clsx'
import { useEffect, useState, type ChangeEvent, type FunctionComponent } from 'react'
import { CustomTooltip } from '../shared/CustomTooltip'
import { Hidden } from '../shared/Hidden'
import style from './Form.module.sass'

type RadioInputProps = {
	label: JSX.Element | string
	name?: string
	value: string | undefined
	inGrid?: boolean
	inColumn?: boolean
	inGridSmall?: boolean
	checked?: boolean
	tooltipText?: JSX.Element
	mobileTooltip?: JSX.Element
	tooltipHovered?: JSX.Element | string
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const RadioInput: FunctionComponent<RadioInputProps> = ({
	label,
	name,
	value,
	inGrid = false,
	inColumn = false,
	inGridSmall = false,
	checked,
	tooltipHovered,
	tooltipText,
	mobileTooltip,
	onChange,
}) => {
	const [labelMobileVisible, setLabelMobileVisible] = useState(false)

	useEffect(() => {
		if (checked) {
			setLabelMobileVisible(true)
		} else {
			setLabelMobileVisible(false)
		}
	}, [checked])

	return (
		<div
			className={clsx(
				style.radioInput,
				inGrid && style.radioInputInGrid,
				inGridSmall && style.radioInputInGridSmall,
				inColumn && style.radioInputInColumn,
			)}
		>
			<label className={style.labelWrapper}>
				<input
					type="radio"
					name={name as string}
					value={value}
					className={style.input}
					checked={checked}
					onChange={onChange}
				/>
				<div
					className={clsx(
						style.label,
						tooltipText && style.labelWithTooltip,
						tooltipText && labelMobileVisible && style.labelWithTooltipMobile,
					)}
				>
					<span className={style.textLabelMobile}>{label}</span>
					<Hidden breakpoint="mobileUp">
						{labelMobileVisible && <div className={style.mobileTooltip}>{mobileTooltip}</div>}
					</Hidden>
					<Hidden breakpoint="mobileDown">
						{tooltipText && tooltipHovered && (
							<div className={style.tooltip} data-tip data-tooltip-id={String(label)}>
								{tooltipHovered}
								<CustomTooltip tooltipId={String(label)} textAfterHover={tooltipText} />
							</div>
						)}
					</Hidden>
				</div>
			</label>
		</div>
	)
}
